export const CURRENT_CONFERENCE_UPDATE = 'CURRENT_CONFERENCE_UPDATE'
export const CUREENT_CONFERENCE_ERROR = 'CUREENT_CONFERENCE_ERROR'

